// extracted by mini-css-extract-plugin
module.exports = {"container":"Form_container__3rAe7","headerContainer":"Form_headerContainer__2ucZI","formContainer":"Form_formContainer__14cds","divider":"Form_divider__3HW5L"};